import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { MaterialType } from "@app/strain/materials/models/material-type.enum";
import { SampleBoardMaterialRecipeItem } from "@app/strain/sample-boards/models/sample-board-material-recipe-item.model";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
    selector: 'app-sample-board-material-scan-item',
    templateUrl: './sample-board-material-scan-item.component.html',
    styleUrls: ['./sample-board-material-scan-item.component.scss']
})
export class SampleBoardMaterialScanItemComponent implements OnInit, OnChanges, OnDestroy {
    @Input() item: SampleBoardMaterialRecipeItem;
    @Input() index: number;
    @Input() canRemove = true;
    @Input() canEdit = true;
    @Input() canEditCode = true;

    @Output() itemChange = new EventEmitter<SampleBoardMaterialRecipeItem>();
    @Output() remove = new EventEmitter<void>();

    @Input() parentForm: FormGroup;
    form: FormGroup;
    private formChangesSub?: Subscription;

    constructor(private fb: FormBuilder) {
    }

    ngOnInit(): void {
        this.initForm();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['item'] && this.form) {
            this.form.patchValue({
                quantity: this.item?.quantity ?? 1,
                materialType: this.item?.material?.type || this.form?.get('materialType')?.value,
                materialId: this.item?.material?.id,
                code: this.item?.code
            }, { emitEvent: false });
        }
    }

    ngOnDestroy(): void {
        this.formChangesSub?.unsubscribe();
    }

    resolveMaterialTypeKey(): string {
        const resolved = this.item?.material?.type;
        switch (resolved) {
            case MaterialType.PCB:
                return 'pcb';
            case MaterialType.Connector:
                return 'connector';
            case MaterialType.Housing:
                return 'housing';
            case MaterialType.Cover:
                return 'cover';
            case MaterialType.Panel:
                return 'panel';
            default:
                return 'material';
        }
    }

    resolveMaterialTypeIcon(): string {
        const resolved = this.item?.material?.type;
        switch (String(resolved)) {
            case String(MaterialType.PCB):
                return 'fa-microchip';
            case String(MaterialType.Connector):
                return 'fa-plug';
            case String(MaterialType.Housing):
                return 'fa-cube';
            case String(MaterialType.Cover):
                return 'fa-clone';
            case String(MaterialType.Panel):
                return 'fa-th-large';
            default:
                return 'fa-tag';
        }
    }

    private initForm(): void {
        this.form = this.parentForm || this.fb.group({
            quantity: [this.item?.quantity ?? 1],
            code: [this.item?.code || '', [Validators.required]]
        });

        this.formChangesSub = this.form.valueChanges.subscribe(value => {
            this.itemChange.emit(new SampleBoardMaterialRecipeItem({
                ...this.item,
                quantity: value.quantity,
                material: this.item?.material,
                code: value.code
            }));
        });
    }
}
